export function downloadPdfFromBase64(encodedFile: string, filename: string, addDateToFilename: boolean = false) {
  const byteArray = Uint8Array.from(atob(encodedFile), (c) => c.charCodeAt(0))
  const blob = new Blob([byteArray], {type: 'application/pdf'});
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  filename = addDateToFilename ? `${filename}_${new Date().toISOString().slice(0, 10)}` : filename;
  link.href = url;
  link.download = `${filename}.pdf`;
  link.click();
  window.URL.revokeObjectURL(url);
}
